import React from "react";
import { HelpCircle } from "lucide-react";

const BondPlayStageHelpButton = ({
  helpLabel = "How this game works",
  onOpenInfo,
  className = "",
}) => (
  <div className={`bplay-stage-help-only${className ? ` ${className}` : ""}`}>
    <button
      type="button"
      className="bplay-stage-header-help"
      aria-label={helpLabel}
      onClick={onOpenInfo}
    >
      <HelpCircle size={17} strokeWidth={2.25} />
    </button>
  </div>
);

export default BondPlayStageHelpButton;
